export default __webpack_public_path__ + "images/dark-theme-logo.png";